import { AfterViewInit, ChangeDetectorRef, Component, HostListener, Injector, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { DateTime } from 'luxon';
import * as moment from 'moment';

import { FRASEHOME, FRASELOGIN, PERMITEAGENCIABUSCARSOMENTEAEREO, PROJETO, SLIDERHOME, SLIDERHOMEDESKTOP, USA_AEREO, USA_BETO, USA_CARRO, USA_CIRCUITOS, USA_CIVITATIS, USASOMENTEIDA } from 'src/app/app.config';
import { Busca, LojasCarros, Pacote, PacotePeriodo, Paginacao, Pais, Quarto, TipoBanner, TIPOBUSCAAEREO, Trecho } from 'src/app/model';
import { BannerService, CarroService, PacotelstService, Util } from 'src/app/services';
import { BuscaComponent } from 'src/app/shared/busca/busca.component';
import { addOrSubtractDays, diffInDays, sameDate, formatDateTime, toDateTime, verifyDateMajorThan } from 'src/app/utils/luxon.helper';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: false
})
export class HomeComponent extends BuscaComponent implements OnInit, AfterViewInit {
    @ViewChild('meuFormulario') meuFormulario!: NgForm;
    formInvalid: boolean = false;

    // Config da home
    i: number;
    sliderhome: string = SLIDERHOME;
    sliderhomeDesktop: string = SLIDERHOMEDESKTOP;
    fraselogin: string = FRASELOGIN;
    frasehome: string = FRASEHOME;
    projeto: string = PROJETO;

    // Formularios
    protected usaAereo = USA_AEREO;
    protected usaAreoApenasIda = USASOMENTEIDA;
    protected usaCarro = USA_CARRO;
    protected usaBetoCarrero = USA_BETO;
    protected usaCircuito = USA_CIRCUITOS;
    protected usaCivitatis = USA_CIVITATIS;
    protected permiteAgenciaBuscarSomenteAereo = PERMITEAGENCIABUSCARSOMENTEAEREO
    private clickSound = new Audio();

    vooDireto: boolean = false;
    promo: boolean = false;
    bagagem: boolean = false;

    paises: (Pais & { display_field: string })[] = [];
    responsiveOptions: { breakpoint: string; numVisible: number; numScroll: number; }[];

    constructor(
        injector: Injector,
        protected titleService: Title,
        protected carroService: CarroService,
        private bannerService: BannerService,
        private cdRef: ChangeDetectorRef,
        private pacoteService: PacotelstService
    ) {
        super(injector);
        this.clickSound.src = 'assets/images/mmc/whip.mp3';
        this.clickSound.load();
        this.responsiveOptions = [
            {
                breakpoint: '1920px',
                numVisible: 4,
                numScroll: 1
            },
            {
                breakpoint: '1590px',
                numVisible: 3,
                numScroll: 1
            },
            {
                breakpoint: '1279px',
                numVisible: 2,
                numScroll: 1
            },
            {
                breakpoint: '856px',
                numVisible: 1,
                numScroll: 1
            }
        ];
    }

    ngOnInit() {
        this.projeto = PROJETO.charAt(0).toUpperCase() + PROJETO.slice(1);
        this.titleService.setTitle('Portal ' + this.projeto)

        super.ngOnInit();
        this.busca.usuario = this.usuarioLogado;

        // Se entrou na Home sem parametro :id, garantir nova busca (não adicionar ao orçamento anterior)
        const idParam = this.route.snapshot.params['id'];
        if (idParam === undefined || idParam === null) {
            this.busca.ReservaId = 0;
            this.busca.novoOrcamento = true;
            this.busca.guid = null;
            this.busca.PacoteId = 0;
            this.busca.primeira = true;
            this.busca.trechos = [];
            this.setUmTrecho();
            window.sessionStorage.removeItem(this.BUSCA);
            window.sessionStorage.removeItem(this.ORCAMENTO);
            window.sessionStorage.removeItem(this.TIMERBUSCA);
        }

        if (this.projeto === "Brasil") {
            this.buscarPacoteDestino(0);
            this.buscarPacotesPorTipo("GUIA");
            this.buscarBanner(TipoBanner.ROTEIROS);
        }

        if (this.busca.ReservaId === 0) {
            this.busca.tipoBusca.aereo = this.usaAereo;
            this.busca.tipoBusca.hotel = true;
            this.busca.tipoBusca.ticket = true;
            this.busca.tipoBusca.beto = false;
            this.busca.tipoBusca.circuito = false;
            this.busca.tipoBusca.servicoExclusivo = this.usaCivitatis;
        }

        if (this.usuarioLogado?.Agencia?.EmpresaId == 3) {
            this.usaBetoCarrero = false;
        }

        this.busca.dataVisitaBetoCarrero = toDateTime(new Date().toISOString());

        this.buscarBanner(TipoBanner.BUSCADOR);

        if (this.Temporadas.length == 0) {
            this.Temporadas.push(formatDateTime(addOrSubtractDays(new Date(), { years: -1 }).toISO(), "yyyy"));
            this.Temporadas.push(formatDateTime(new Date(), "yyyy"));
            this.Temporadas.push(formatDateTime(addOrSubtractDays(new Date(), { years: 1 }).toISO(), "yyyy"));
            this.Temporada = this.Temporadas[0];
        }
    }

    ngAfterViewInit() {
        super.ngAfterViewInit();
        let paiscache = window.sessionStorage.getItem("zfjd87");
        if (paiscache != null) {
            this.setarPaisAgencia();
        } else {
            setTimeout(() => this.setarPaisAgencia(), 2500);
        }

        this.pickers = this.datepickers.toArray();
        this.cdRef.detectChanges();
    }

    validarFormulario() {
        if (this.meuFormulario.valid) {
            this.verificaAgencia()
        } else {
            console.log('Formulário inválido!');
            this.meuFormulario.form.markAllAsTouched();
        }
    }


    buscaPaisDebounce(val: string) {
        clearTimeout(this.timerPais);
        this.timerPais = setTimeout(() => {
            this.buscaPais(val);
        }, 600);
    }

    timerPais = null;

    playSound(): void {
        const chance = Math.random();
        if (!this.busca.tipoBusca.beto && chance < 0.01) {
            console.log('Reproduzindo o som raro');
            this.clickSound.currentTime = 0; // Reseta o tempo do áudio
            this.clickSound.volume = 0.4; // Define o volume do som
            this.clickSound.play().catch(error => {
                console.error('Erro ao reproduzir o som:', error);
            });
        }
    }

    buscaPais(val: string) {
        this.paisService.buscarPorParametro(val, 1).subscribe(
            (dados) => {
                this.paises = dados.Items.map((x) => {
                    x.display_field = x.Nome;
                    return x;
                });
            },
            (erro) => {
                console.log(erro);
                this.paises = [];
            }
        );
    }

    selecionaPaisNacionalidade(item) {
        this.busca.nacionalidadePax = item;
        this.busca.quartos = this.busca.quartos.map((x) => {
            x.nacionalidadePaxQuarto = item.Iata;
            return x;
        });

        let paiscache = window.localStorage.getItem("zfjd87");

        if (paiscache != null) {
            window.localStorage.removeItem("zfjd87");
            window.localStorage.setItem("zfjd87", btoa(JSON.stringify(item)));
        } else {
            window.localStorage.setItem("zfjd87", btoa(JSON.stringify(item)));
        }
    }

    buscarBanner(tipo: string) {
        this.bannerService.getBanner(tipo).subscribe(
            dados => {
                try {
                    if (tipo == TipoBanner.BUSCADOR) {
                        this.sliderhomeDesktop = dados ? Util.pathImagemApi(dados.ImagemURL) : SLIDERHOMEDESKTOP;
                    } else if (tipo == TipoBanner.ROTEIROS) {
                        this.sliderhome = dados ? Util.pathImagemApi(dados.ImagemURL) : SLIDERHOME;
                    }
                } catch (error) {
                    console.log(error);
                }
            },
            erro => {
                console.log(erro);
            }
        );
    }

    setarPaisAgencia() {
        let user = window.localStorage.getItem("loggedUser");
        if (user != null) {
            let u = JSON.parse(user);

            let paiscache = window.localStorage.getItem("zfjd87");

            if (paiscache != null) {
                let pais = JSON.parse(atob(paiscache));

                this.busca.quartos = this.busca.quartos.map((x) => {
                    x.nacionalidadePaxQuarto = pais.Iata;
                    return x;
                });
                this.busca.nacionalidadePax = pais;
                this.busca.nacionalidadePax.Nome = pais.Nome;
            } else {
                if (u.Agencia != null && u.Agencia != undefined) {
                    this.cidadeService.buscarPorId(u.Agencia.CidadeId).subscribe(
                        (dados) => {
                            this.busca.quartos = this.busca.quartos.map((x) => {
                                x.nacionalidadePaxQuarto = dados.Items[0].Estado.Pais.Iata;
                                return x;
                            });
                            this.busca.nacionalidadePax = dados.Items[0].Estado.Pais;
                            this.busca.nacionalidadePax.Nome =
                                dados.Items[0].Estado.Pais.Nome;

                            window.localStorage.setItem(
                                "zfjd87",
                                btoa(JSON.stringify(dados.Items[0].Estado.Pais))
                            );
                        },
                        (erro) => {
                            console.log(erro);
                        }
                    );
                } else if (u.Empresa != null && u.Empresa != undefined) {
                    this.cidadeService.buscarPorId(u.Empresa.CidadeId).subscribe(
                        (dados) => {
                            this.busca.quartos = this.busca.quartos.map((x) => {
                                x.nacionalidadePaxQuarto = dados.Items[0].Estado.Pais.Iata;
                                return x;
                            });
                            this.busca.nacionalidadePax = dados.Items[0].Estado.Pais;
                            this.busca.nacionalidadePax.Nome =
                                dados.Items[0].Estado.Pais.Nome;

                            window.localStorage.setItem(
                                "zfjd87",
                                btoa(JSON.stringify(dados.Items[0].Estado.Pais))
                            );
                        },
                        (erro) => {
                            console.log(erro);
                        }
                    );
                }
            }
        }
    }

    tirouAereo() {
        this.tipoAereo(TIPOBUSCAAEREO.idaVolta);
        this.busca.trechos = [];
        this.busca.trechos.push(new Trecho());
        this.pickers = this.datepickers.toArray();
        this.cdRef.detectChanges();
    }

    setAgencia() {
        let usuario = JSON.parse(localStorage.getItem('loggedUser'));
        let agencia = localStorage.getItem('g8h7d8');

        if (usuario.Agencia === null || usuario.Agencia === undefined) {
            localStorage.setItem('g8h7d8', btoa(JSON.stringify(agencia)));
        } else if (usuario.Agencia != null && usuario.Agencia != undefined) {
            localStorage.setItem('g8h7d8', btoa(JSON.stringify(usuario.Agencia)));
        }
    }

    verificaAgencia() {
        let agencia = window.localStorage.getItem('g8h7d8');

        if (agencia != null) {
            agencia = JSON.parse(atob(agencia));
        }

        if (agencia || this.usuarioLogado.AgenciaId != null) {
            this.buscar();
        } else {
            alert("Selecione uma agência para continuar!")
        }
    }

    negar(item) {
        switch (item) {
            case 'aereo':
                this.busca.tipoBusca.aereo = !this.busca.tipoBusca.aereo;
                break;

            case 'hotel':
                this.busca.tipoBusca.hotel = !this.busca.tipoBusca.hotel;
                break;

            case 'servico':
                this.busca.tipoBusca.ticket = !this.busca.tipoBusca.ticket;
                break;

            case 'vooDireto':
                this.vooDireto = !this.vooDireto;
                break;

            case 'promo':
                this.promo = !this.promo;
                break;

            case 'bagagem':
                this.bagagem = !this.bagagem;
                break;

            case 'beto':
                this.busca.tipoBusca.beto = !this.busca.tipoBusca.beto;
                break;
        }
    }

    limpaPesquisa() {
        this.busca.trechos = [];
        this.setUmTrecho();
        sessionStorage.removeItem(this.BUSCA);
        sessionStorage.removeItem(this.ORCAMENTO);
    }

    limpaPesquisaCompleta() {
        this.limpaPesquisa();
        this.setUmTrecho();
    }

    tipoAereo(item: TIPOBUSCAAEREO) {
        this.limpaPesquisa();
        switch (item) {
            case (TIPOBUSCAAEREO.ida):

                this.busca.tipoBuscaAereo = TIPOBUSCAAEREO.ida;
                if (this.busca.trechos.length > 1) {
                    this.busca.trechos = [];
                    this.setUmTrecho();
                }
                break;

            case (TIPOBUSCAAEREO.idaVolta):

                this.busca.tipoBuscaAereo = TIPOBUSCAAEREO.idaVolta;

                if (this.busca.trechos.length > 1) {
                    this.busca.trechos = [];
                    this.setUmTrecho();
                }
                break;

            case (TIPOBUSCAAEREO.multiplosTrechos):
                this.busca.tipoBuscaAereo = TIPOBUSCAAEREO.multiplosTrechos;
                this.busca.trechos = [];
                this.setUmTrecho();
                while (this.busca.trechos.length < 2) {
                    this.setUmTrecho();
                }
                break;
        }

        if (this.busca.trechos.length < 1) {
            this.setUmTrecho();
        }

        this.pickers = this.datepickers.toArray();
    }

    setUmTrecho() {
        this.busca.trechos.push(new Trecho());

        if (this.busca.tipoBuscaAereo === TIPOBUSCAAEREO.multiplosTrechos && this.busca.trechos.length >= 2) {
            let dataBase = toDateTime(new Date().toISOString());
            this.busca.trechos.reduce((prevDate, trecho, index) => {
                trecho.dataIda = index === 0 ? prevDate : addOrSubtractDays(prevDate, { days: 1 });
                trecho.minDataIda = prevDate;
                return trecho.dataIda;
            }, dataBase);
        }

        this.busca.localOrigem = new LojasCarros();
        this.busca.localDevolucao = new LojasCarros();

        this.cdRef.detectChanges();
    }

    removerTrecho(indice) {
        if (indice === undefined) {
            this.busca.trechos.pop();
        } else {
            this.busca.trechos.splice(indice, 1);
        }
    }

    setDataBeto(event) {
        this.busca.dataVisitaBetoCarrero = event;
    }

    // setDataParaAmanha() {
    //     this.busca.dataVisitaBetoCarrero = this.getAmanha();
    // }

    getMinDataVisita(trecho: any) {
        return trecho?.dataIda ? trecho.dataIda : this.getAmanha();
    }

    abrirModal(contentModal) {
        this.modalService.open(contentModal, { size: 'md', backdrop: 'static', centered: true });
    }

    fecharModal() {
        this.modalService.dismissAll();
    }

    permitirSomenteDatas(event: KeyboardEvent) {
        const regex = /^[0-9]*$/;
        const key = event.key;

        if (!regex.test(key)) {
            event.preventDefault();
        }
    }

    trackByIndex(index: number, item: any): number {
        return index;
    }


    // BrasilOperadora
    paginacao: Paginacao = new Paginacao();
    segundoCarrousselPacotes: Pacote[] = [];
    pacotes: Pacote[] = [];
    Pacotes: Pacote[] = [];
    PacoteDetalhes: any;
    desabilitaTarifa = true;
    datasvalidas = [];
    usaMinNoites = false;
    erros = [];
    mensagemSucesso = '';
    Pacote: Pacote;
    minDateModal: DateTime;
    maxDate: DateTime;
    semAgencia: boolean = false;
    innerWidth: number = window.innerWidth;
    @HostListener('window:resize', ['$event'])

    myFilterData = (d: Date): boolean => {
        const date = toDateTime(d);
        return this.datasvalidas.indexOf(date.toFormat("yyyy-MM-dd")) !== -1;
    };

    incrementaQuartos() {
        this.busca.quartos.push(new Quarto());
    }

    decrementaQuartos() {
        this.busca.quartos.pop();
    }

    abrirModalPacote(pacote: Pacote, content) {
        this.desabilitaTarifa = true;
        this.usaMinNoites = false;
        this.Pacote = pacote;
        this.busca.tipoBusca.hotel = true;
        this.busca.usuario = this.usuarioLogado;
        this.datasvalidas = [];

        if (pacote.PacotePeriodos.length > 0) {
            pacote.PacotePeriodos.forEach((pp: PacotePeriodo, index: number) => {
                this.datasvalidas.push(toDateTime(pp.CheckinDe).toFormat('yyyy-MM-dd'));
                if (index === 0) {
                    this.busca.trechos[0].dataIda = toDateTime(pp.CheckinDe);
                    this.setDataIda(this.busca.trechos[0].dataIda, this.busca.trechos, 0);
                }
            });
            this.busca.nrnoites = diffInDays(toDateTime(pacote.PacotePeriodos[0].CheckinDe), toDateTime(pacote.PacotePeriodos[0].CheckoutAte));
        } else {
            let dataCheckin = toDateTime(pacote.Checkin);

            // this.minDate = pacote.Checkin < this.getAmanha() ? this.getAmanha() : this.formatarData(pacote.Checkin);
            this.minDateModal = verifyDateMajorThan(toDateTime(pacote.Checkin), this.getAmanha()) ? this.getAmanha() : dataCheckin;
            this.maxDate = toDateTime(pacote.Checkout);

            this.usaMinNoites = true;
            this.busca.trechos[0].dataIda = this.minDateModal;
            this.busca.trechos[0].dataVolta = this.maxDate;
            this.setDataIdaPacote(this.minDateModal, this.busca.trechos, 0);
            this.busca.nrnoites = pacote.MinimoDeNoites;
        }
        // this.atualizarBusca.emit(busca);

        sessionStorage.clear();
        this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true, size: 'lg' });
    }

    setDataIdaPacote(event: any, trechos: Trecho[], indice: number = 0) {
        this.desabilitaTarifa = false;

        let periodo = this.Pacote.PacotePeriodos.find(x => sameDate(event, x.CheckinDe));

        let dataIda = toDateTime(event);
        let dataVolta = toDateTime(new Date());

        if (this.usaMinNoites) {
            dataVolta = dataIda.plus({ days: this.Pacote.MinimoDeNoites });
        } else if (periodo) {
            dataVolta = toDateTime(periodo.CheckoutAte);
        }

        this.busca.trechos[indice].dataIda = dataIda;
        this.busca.trechos[indice].dataVolta = dataVolta;

        this.busca.nrnoites = diffInDays(dataIda, dataVolta);
    }

    isMobile(aonde: string) {
        switch (aonde) {
            case 'h':
                return this.innerWidth <= 795;
            case 's':
                return this.innerWidth <= 1583;
        }
    }
    buscarPacoteDestino(destinoId) {
        // this.loading = true;
        // this.erros = [];
        // this.mensagemSucesso = '';
        this.pacoteService.buscaPacotesDestinos(destinoId, this.paginacao.NumeroPagina).subscribe(
            dados => {
                dados.Items.forEach(p => {
                    p.PacoteImagens.forEach(pi => {
                        pi.Imagem = Util.pathImagemApi(pi.Imagem);
                    });
                    p.PacotePeriodos.forEach(pp => {
                        pp.CheckinDe = moment(pp.CheckinDe).format("YYYY-MM-DD");
                        pp.CheckoutAte = moment(pp.CheckoutAte).format("YYYY-MM-DD");
                    });
                    p.PacotePeriodos.sort(function (a, b) {
                        return a.CheckinDe - b.CheckinDe;
                    });
                });

                this.segundoCarrousselPacotes = dados.Items.filter(pacote => pacote.Destaque);

                this.paginacao.NumeroPagina = dados.MetaData.NumeroPagina;
                this.paginacao.TotalItens = dados.MetaData.TotalItens;
                this.paginacao.ItensPorPagina = dados.MetaData.itensPorPagina;
                this.paginacao.TotalPaginas = dados.MetaData.TotalPaginas;
                // this.loading = false;
            },
            erro => {
                // this.loading = false;
                this.pacotes = [];
                // this.erros.push('Erro ao buscar o pacote.');
            },
        );
    }

    buscarPacotesPorTipo(tipo: string) {
        this.pacoteService.buscarPorTipo(tipo).subscribe(
            dados => {
                dados.forEach(p => {
                    p.PacoteImagens.forEach(pi => {
                        pi.Imagem = Util.pathImagemApi(pi.Imagem);
                    });
                    p.PacotePeriodos.forEach(pp => {
                        pp.CheckinDe = moment(pp.CheckinDe).format("YYYY-MM-DD");
                        pp.CheckoutAte = moment(pp.CheckoutAte).format("YYYY-MM-DD");
                    });
                    p.PacotePeriodos.sort(function (a, b) {
                        return a.CheckinDe - b.CheckinDe;
                    });
                });

                this.pacotes = dados;

                // this.paginacao.NumeroPagina = dados.MetaData.NumeroPagina;
                // this.paginacao.TotalItens = dados.MetaData.TotalItens;
                // this.paginacao.ItensPorPagina = dados.MetaData.itensPorPagina;
                // this.paginacao.TotalPaginas = dados.MetaData.TotalPaginas;
                // this.loading = false;
            },
            erro => {
                // this.loading = false;
                this.pacotes = [];
                // this.erros.push('Erro ao buscar o pacote.');
            },
        );
    }

    BuscaPacotes() {
        // this.semAgencia = false;
        this.busca.primeira = true;
        this.busca.novoOrcamento = true;
        this.busca.ReservaId = 0;
        this.busca.PacoteId = this.Pacote.Id;
        if (this.Pacote.BloqueioAereo.length > 0) {
            this.busca.trechos[0].AeroportoPartida = this.Pacote.BloqueioAereo[0].AeroportoPartida;
            this.busca.trechos[0].AeroportoChegada = this.Pacote.BloqueioAereo[0].AeroportoChegada;
        } else {
            this.busca.tipoBusca.aereo = false;
        }
        this.busca.trechos[0].cidadeDestino.Id = this.Pacote.Cidade.Id;
        this.busca.trechos[0].cidadeDestino.Nome = this.Pacote.Cidade.Nome;

        if (this.usuarioLogado?.AgenciaId != null) {
            this.busca.AgenciaId = this.usuarioLogado.AgenciaId;
        } else {
            let agencia = window.localStorage.getItem("g8h7d8");
            if (agencia !== null) {
                const agenciaID = JSON.parse(atob(agencia));
                this.busca.AgenciaId = agenciaID.Id;
            } else {
                alert("Selecione uma agência!");
                // alert(this.utilService.fazerTraducao(this.mensagemAlert));
            }
        }
        if (!this.busca.AgenciaId || this.busca.AgenciaId == 0) {
            this.semAgencia = true;
            setTimeout(() => (this.semAgencia = false), 5000);
            return null;
        }

        sessionStorage.removeItem('buscapacote');
        sessionStorage.setItem('buscapacote', JSON.stringify(this.busca));

        this.modalService.dismissAll();
        this._router.navigate([`listagem-pacotes/pacote-hotel`]);
    }

    marcarCircuito() {
        if (!this.busca.tipoBusca.circuito) {
            this.busca.tipoBusca.aereo = false;
            this.busca.tipoBusca.hotel = false;
            this.busca.tipoBusca.ticket = false;
            this.busca.tipoBusca.servicoExclusivo = false;
        } else {
            if (this.usaAereo) {
                this.busca.tipoBusca.aereo = true;
            } else {
                this.busca.tipoBusca.hotel = true;
            }
        }
    }
    naoCircuito() {
        if (!this.busca.tipoBusca.aereo || !this.busca.tipoBusca.hotel || !this.busca.tipoBusca.ticket || !this.busca.tipoBusca.servicoExclusivo) {
            this.busca.tipoBusca.circuito = false;
        }
    }
}
